import React, { useEffect, useId, useState } from 'react';
import mermaid from 'mermaid';

type MermaidDiagramProps = {
  chart: string;
  className?: string;
};

export const MermaidDiagram: React.FC<MermaidDiagramProps> = ({ chart, className }) => {
  const [svg, setSvg] = useState('');
  const [error, setError] = useState<string | null>(null);
  const id = useId().replace(/:/g, '');

  useEffect(() => {
    let active = true;
    setSvg('');
    setError(null);
    mermaid.initialize({
      startOnLoad: false,
      theme: 'dark',
      securityLevel: 'loose',
      themeVariables: {
        background: '#0f172a',
        primaryColor: '#6d28d9',
        primaryTextColor: '#f9fafb',
        primaryBorderColor: '#7c3aed',
        lineColor: '#6b7280',
        secondaryColor: '#111827',
        tertiaryColor: '#1f2937',
        fontFamily: 'inherit',
      },
    });

    mermaid
      .render(`dungeon-flow-${id}`, chart)
      .then(({ svg: nextSvg }) => {
        if (active) setSvg(nextSvg);
      })
      .catch((err) => {
        if (!active) return;
        const message = err instanceof Error ? err.message : String(err);
        setError(message || 'Unknown mermaid error');
        setSvg('');
        console.error('Mermaid render failed', err);
      });

    return () => {
      active = false;
    };
  }, [chart, id]);

  if (!svg) {
    return (
      <div className={className}>
        <div className="text-sm text-gray-400">Diagram unavailable.</div>
        {error && (
          <div className="mt-2 text-xs text-red-400 whitespace-pre-wrap break-words">
            {error}
          </div>
        )}
        <details className="mt-3 text-xs text-gray-400">
          <summary className="cursor-pointer text-gray-300">Show chart source</summary>
          <pre className="mt-2 whitespace-pre-wrap break-words text-gray-400">{chart}</pre>
        </details>
      </div>
    );
  }

  return <div className={className} dangerouslySetInnerHTML={{ __html: svg }} />;
};
